import { __decorate } from "tslib";
import ConfirmableButton from "@/components/ConfirmableButton.vue";
import TreatmentCard from "@/Pages/People/Customer/TreatmentPlan/TreatmentCard.vue";
import ToothPopover from "@/components/Tooth/ToothPopover.vue";
import ToothParts from "@/components/Tooth/Parts.vue";
import ModalMixin from "@/mixins/modal-mixin";
import draggable from "vuedraggable";
import { Component, Inject, Prop, Emit } from "vue-property-decorator";
import { mapActions } from "vuex";
let Stages = class Stages extends ModalMixin {
    plan;
    printMode;
    editMode;
    openBrowser;
    selectedTreatments = [];
    patch;
    get customerId() {
        return this.plan.customerId;
    }
    toggleEditMode() {
        return !this.editMode;
    }
    selectCurrent() {
        return this.$vnode.key;
    }
    created() {
        this.$root.$on("work-order-confirmed", (confirmedCarts) => {
            const localCartsCopy = this.$copy(confirmedCarts);
            for (const confirmedCart of localCartsCopy) {
                this.completeTreatment(confirmedCart);
            }
            // deselect confirmed stages
            this.selectedTreatments = this.selectedTreatments.filter(treatment => !(Object.values(confirmedCarts).flat().some(completedTreatment => completedTreatment._id === treatment.treatment._id)));
            this.savePlan(this.plan);
        });
    }
    completeTreatment(treatment) {
        if (!treatment.tooths.length)
            treatment.tooths = [null];
        treatment.tooths.forEach(toothFromCart => {
            // find tooth in plan
            let tooth = this.plan.teeth.find(toothFromPlan => toothFromPlan.tooth === toothFromCart);
            if (tooth) {
                this.completeTooth(treatment, tooth);
            }
        });
    }
    completeTooth(cart, tooth) {
        for (const [, stage] of Object.entries(tooth.stages)) {
            stage.forEach(stageEntity => {
                // check if stage is confirmed
                if (stageEntity.treatmentId === cart.item._id && // if this stage is added to work order
                    !stageEntity.completed && // if this stage is not already completed
                    cart.quantity > 0 // if there are still treatments in cart
                ) {
                    // complete stage
                    stageEntity.completed = true;
                    stageEntity.completedAt = new Date().toString();
                    cart.quantity--; // decrease cart quantity to obtain repeatings
                }
            });
        }
    }
    showAddToCartButton(tooth, toothIdx) {
        return this.selectedTreatments.some(el => el.tooth === tooth);
    }
    savePlan(plan) {
        return this.patch([plan._id, plan, {}]);
    }
    setOrder(toothIdx, stage, treatments) {
        treatments.forEach((item, index) => (item.priority = index));
        let plan = this.$deepCopy(this.plan);
        plan.teeth[toothIdx].stages[stage] = treatments;
        this.savePlan(plan);
    }
    setTooth(toothIdx, tooth) {
        if (!tooth[0])
            return;
        let plan = this.$deepCopy(this.plan);
        plan.teeth[toothIdx].tooth = tooth[0];
        this.savePlan(plan);
        this.$root.$emit("bv::hide::popover");
    }
    saveChange(toothIdx, stage, treatmentIdx, item) {
        let plan = this.$deepCopy(this.plan);
        if (item)
            plan.teeth[toothIdx].stages[stage][treatmentIdx] = item;
        else
            plan.teeth[toothIdx].stages[stage].splice(treatmentIdx, 1);
        this.savePlan(plan);
    }
    addStage(toothIdx) {
        let plan = this.$deepCopy(this.plan);
        const newStage = this.getLastStage(plan, toothIdx) + 1;
        plan.teeth[toothIdx].stages[newStage] = [];
        this.savePlan(plan);
    }
    getLastStage(plan, toothIdx) {
        const stageIdxs = Object.keys(plan.teeth[toothIdx].stages).map(el => parseInt(el));
        if (!stageIdxs.length)
            return 0;
        return Math.max(...stageIdxs);
    }
    removeStage(toothIdx) {
        let plan = this.$deepCopy(this.plan);
        const lastStage = this.getLastStage(plan, toothIdx);
        delete plan.teeth[toothIdx].stages[lastStage];
        this.savePlan(plan);
    }
    removeTooth(tooth) {
        let plan = this.$deepCopy(this.plan);
        const idx = plan.teeth.findIndex((el) => el.tooth === tooth);
        plan.teeth.splice(idx, 1);
        this.savePlan(plan);
    }
    addToCart() {
        // group treatments by their id
        let groupedByIdTreatments = this.$groupBy(this.selectedTreatments, el => el.treatment._id);
        let carts = Object.values(groupedByIdTreatments).reduce((result, groupedItems) => {
            let quantity = groupedItems.length;
            let tooths = groupedItems.map(el => el.tooth).filter((el) => el !== null); // collect their tooth values into array
            let treatment = groupedItems[0].treatment;
            return [
                ...result,
                {
                    _id: treatment._id,
                    grouped: false,
                    tooths,
                    quantity,
                    item: treatment,
                    price: treatment.price
                }
            ];
        }, []);
        const { Cart } = this.$FeathersVuex;
        new Cart({
            _id: "temp",
            model: {
                customerId: this.customerId,
                userId: this.plan.userId,
                carts,
            }
        });
        this.openModal({ id: "invoiceCheckout" });
    }
};
__decorate([
    Prop({ type: Object, required: true })
], Stages.prototype, "plan", void 0);
__decorate([
    Prop({ type: Boolean })
], Stages.prototype, "printMode", void 0);
__decorate([
    Prop({ type: Boolean })
], Stages.prototype, "editMode", void 0);
__decorate([
    Inject('openBrowser')
], Stages.prototype, "openBrowser", void 0);
__decorate([
    Emit('update:editMode')
], Stages.prototype, "toggleEditMode", null);
__decorate([
    Emit('update:selectedIndex')
], Stages.prototype, "selectCurrent", null);
Stages = __decorate([
    Component({
        components: {
            ConfirmableButton,
            TreatmentCard,
            ToothParts,
            ToothPopover,
            draggable
        },
        methods: {
            ...mapActions("treatment-plan", ["patch", "remove"]),
        }
    })
], Stages);
export default Stages;
